export default `float s=2.,e;
    for(int i=0;i<9;i++){
      p=.5-abs(p-.5);
      p.x < p.z?p=p.zyx:p;
      p.z < p.y?p=p.xzy:p;
      s*=e=2.4;
      p=abs(p)*e-vec3(.1,13.0,5.0);
    }
    return length(p)/s-0.01;
  }`